<template>
  <div class="atividades-afdLancamentos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <!-- -->
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-status">Status</label>

          <multiselect
            id="selecao-status-sol"
            v-model="value_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data Inicial</label>
            <b-form-datepicker
              id="dt_registro"
              required
              v-model="dt_registro_inicio"
              placeholder="Dia trabalhado "
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1">
          <div>
            <label for="datepicker-placeholder">Data Fim</label>
            <b-form-datepicker
              id="dt_registro"
              required
              v-model="dt_registro_fim"
              placeholder="Dia trabalhado "
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            @click="loadPonLançamentosAfd()"
            block
          >
            Carregar
          </b-button>
        </b-col>

        <b-col cols="2" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Função "
          ></b-form-input>
        </b-col>
      </b-row>
    </b-form>

    <LoadingModal v-if="isLoading" />

    <b-row>
      <b-col cols="7">
        <label for="input-live">Cabeçalho</label>
        <b-input-group-text id="cabecalho">
          {{
            afdLancamentos && afdCAbecalhos.length > 0
              ? `${afdCAbecalhos[0].padrao} 
                           ${afdCAbecalhos[0].tipo_registro} 
                           ${afdCAbecalhos[0].tipo_identificador_empregador} 
                           ${afdCAbecalhos[0].cnpj_cpf} 
                           ${afdCAbecalhos[0].cno_caepf} 

                           ${afdCAbecalhos[0].razaosocial} 
                           ${afdCAbecalhos[0].repc_repa} 
                           ${dt_registro_inicio} 
                           ${dt_registro_fim}                            
                           ${dt_geracao_afd} 

                           ${afdCAbecalhos[0].versao_leitura_afd} 
                           ${afdCAbecalhos[0].tipo_identificador_fab_desenvolvedor_rep} 
                           ${afdCAbecalhos[0].cnpj_cpf_desenvolvedor_rep} 
                           ${afdCAbecalhos[0].modelo_repc}                            
                           ${afdCAbecalhos[0].crc16}                            
                          `
              : "-"
          }}
        </b-input-group-text>
      </b-col>

      <b-col cols="3">
        <label for="input-live">Trailer</label>
        <b-input-group-text id="trailer">
          {{
            afdLancamentos && afdCAbecalhos.length > 0
              ? `${(999999999).toString().padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 2)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 3)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 4)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 5)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 6)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${itemsFiltered
                                  .filter((s) => s.tipo_registro == 7)
                                  .length.toString()
                                  .padEnd(9, " ")} 
                                ${"9".padEnd(9, " ")}
                            `
              : "-"
          }}
          <!-- {{ itemsFiltered.filter( s => s.tipo_registro == 7).length }} -->
        </b-input-group-text>
      </b-col>

      <b-col cols="1">
        <br />
        <b-button
          variant="success"
          class="mr-2 mt-2"
          @click="generateAfdFile(), putAfdExportado()"
          block
        >
          Gerar AFD
        </b-button>
      </b-col>

      <b-col cols="1">
        <br />
        <b-button
          variant="warning"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-2
          block
        >
          Parâmetros
        </b-button>
      </b-col>
    </b-row>

    <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
    <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="TOTAL DE REGISTROS"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ itemsFiltered.length }}
          </h2>
        </b-card-text>
      </b-card>
    </b-card-group>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="resolicitante"
      small
      hover
      striped
      sticky-header="666px"
      :items="itemsFiltered"
      :fields="fieldsSolicitado"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            loadCarregaSac(data.item),
              loadPonLançamentosAfdTratativas(),
              loadStatus()
          "
          title="Editar solicitação"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-2
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-2"
        cancel-title="Fechar"
        ok-title="Gravar"
        @ok="postSac()"
        size="xl"
        :title="`Solicitação Nº.: ${
          sacsolicitacao.id_solicitacao != null
            ? sacsolicitacao.id_solicitacao
            : '-'
        }`"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- ,postSacTratativa(),putSacTratativa(),postNotificacao() -->
        <div>
          <b-row
            v-if="
              sacsolicitacao.id_solicitacao !== '' &&
              sacsolicitacao.id_solicitacao !== null
            "
          >
            <input
              id="id-sac"
              type="hidden"
              v-model="sacsolicitacao.id_solicitacao"
            />

            <b-col cols="1" class="mt-2 pr-4">
              <b-form-group label="" label-for="tabela-foto">
                <b-img
                  height="120"
                  width="78"
                  class="mb-5"
                  v-model="sacsolicitacao.foto_url"
                  v-bind="mainProps"
                  rounded
                  alt="Foto"
                  :src="sacsolicitacao.foto_url"
                >
                </b-img>
              </b-form-group>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Registro</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.re_solicitante"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Nome</label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.nome"
                readonly
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Função </label>
              <b-form-input
                id="resolicitante"
                v-model="sacsolicitacao.funcao_solicitante"
                readonly
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="1" class="mt-5">
              <label for="input-live"> </label>
              <b-button
                block
                variant="warning"
                class="mr-2 mt-1"
                @click="loadSolicitacaoFoto()"
                v-b-modal.modal-SolicitacaoFotos
                >Fotos</b-button
              >
            </b-col>
          </b-row>

          <b-row
            v-if="
              sacsolicitacao.id_solicitacao == '' ||
              sacsolicitacao.id_solicitacao == null
            "
          >
            <b-col sm="3">
              <label for="textarea-small">Justificativa</label>
            </b-col>
            <b-col sm="12">
              <b-form-textarea
                id="id-pecas"
                v-model="sacsolicitacao.justificativa"
                readonly
                size="sm"
                class="mb-3"
                placeholder="Pergunta do colaborador"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <b-row
            v-if="
              sacsolicitacao.id_solicitacao == '' ||
              sacsolicitacao.id_solicitacao == null
            "
          >
            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Departamento</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.departamento_id"
                  :options="departamentos"
                  class="mb-3"
                  text-field="area"
                  @change="loadAssunto()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Assunto</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.assunto_id"
                  :options="assuntos"
                  class="mb-3"
                  text-field="modulo"
                  @change="loadMotivo()"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4" sm="4" class="mt-1">
              <label for="input-parecer">Motivo</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="sacsolicitacao.motivo_id"
                  :options="motivos"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Tratativas -->
          <div class="d-flex justify-content-center mb-3">
            <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
          </div>
          <!--tbl de dados -->
          <b-table
            id="resolicitante"
            v-if="
              sacsolicitacao.id_solicitacao !== '' ||
              sacsolicitacao.id_solicitacao !== null
            "
            small
            hover
            striped
            sticky-header="330px"
            :items="afdLancamentostratativa"
            :fields="tratativas"
          >
          </b-table>

          <b-row>
            <b-col sm="12">
              <label for="textarea-small">Parecer da solicitação:</label>
            </b-col>

            <b-col cols="10">
              <b-form-textarea
                id="id-obs"
                v-model="sacsolicitacao.parecer"
                size="sm"
                placeholder="Digite o parecer"
              ></b-form-textarea>
            </b-col>

            <b-col v-if="this.user.gestor" cols="2" class="mb-1">
              <b-form-checkbox
                id="aprovado"
                v-model="sacsolicitacao.aprovado"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
                @change="handleCheckboxChange"
              >
                Aprovado compra
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10" class="mt-2" v-if="sacsolicitacao.id_status == 3">
              <label for="textarea-small">Avaliação do atendimento:</label>
              <b-form-rating
                v-model="sacsolicitacao.avaliacao"
                @change="uptAvaliacao()"
              ></b-form-rating>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="mb-3 mt-3 ml-5">
              <div>
                <b-img
                  v-if="sacsolicitacao.file === 'true'"
                  :src="sacsolicitacao.file"
                  width="600"
                  height="600"
                ></b-img>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

    <div>
      <b-modal
        id="modal-SolicitacaoFotos"
        hide-footer
        size="lg"
        :title="`Fotos da solicitação: ${sacsolicitacao.id_solicitacao}`"
        no-close-on-backdrop
      >
        <div class="d-flex justify-content-center" style="height: 80vh">
          <b-carousel
            id="carouselFoto"
            class="carouselFoto"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              v-for="item in solicitacao"
              :key="item.id"
              :img-src="item.foto_thumbnail"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SacSolicitacao",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = []; //    afdLancamentos
      valores = this.afdLancamentos.filter((item) => {
        return (
          item.registro.indexOf(this.search) > -1 ||
          item.funcao.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      dt_registro_inicio: "",
      dt_registro_fim: "",
      dt_geracao_afd: now(),
      afdCAbecalhos: [], // [] lista
      sacsolicitacao: {}, // [] lista
      afdLancamentos: [], // [] lista

      sacT: {}, // [] lista
      afdLancamentostratativa: [], // [] lista
      search: "",
      departamentos: [],
      assuntos: [],
      motivos: [],
      idRetornoSolicitacao: [],
      solicitacao: [],

      mode: "save",

      atualizando: false,
      isLoading: false,
      empresa: {},
      empresas: [], // [] lista
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      filial: {},
      filiais: [], // [] lista
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      value_id_area: "",
      barra_inicial: 0,
      barra_limite: 60000 * 5, // temporizador 60.000 milisegundos refere-se a 1 minutos

      fieldsSolicitado: [
        { key: "filial_id", label: "Filial", sortable: true },
        {
          key: "dt_servico",
          label: "Data Operação",
          sortable: true,
          formatter: (value, key, afdLancamentos) => {
            return moment(afdLancamentos.dt_servico)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        { key: "registro", label: "RE", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "nsr", label: "Nsrº", sortable: true },
        { key: "tipo_registro", label: "Tipo Registro", sortable: true },
        { key: "cpf", label: "CPF", sortable: true },
        { key: "legenda", label: "Atividade", sortable: true },
        {
          key: "dt_marcacao",
          label: "Ponto Registrado",
          sortable: true,
          formatter: (value, key, afdLancamentos) => {
            return moment(afdLancamentos.dt_marcacao)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "afd_dt_geracao",
          label: "Data exportação",
          sortable: true,
          formatter: (value, key, afdLancamentos) => {
            return moment(afdLancamentos.afd_dt_geracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "coletor", label: "Coletor", sortable: true },
        { key: "tipo_marcacao", label: "OnLine / OffLine", sortable: true },
        { key: "codigohash", label: "Código hash", sortable: true },

        /*
                { key: 'actions', label: 'Atualizar' },                
                 */
      ],
      //////// defeitos da corretiva

      tratativas: [
        {
          key: "dt_resposta",
          label: "Data_Resposta",
          sortable: true,
          formatter: (value, key, afdLancamentostratativa) => {
            return moment(afdLancamentostratativa.dt_resposta)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        { key: "respondido", label: "Resposta", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "justificativa", label: "Justificativa", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa:
          this.value_empresa.length > 0
            ? this.value_empresa.map((e) => e.id_empresa).join(",")
            : this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/pontoeletronico/afd/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id_status, status: sta.status };
        });
      });
    },

    loadPonLançamentosAfd() {
      this.isLoading = true; // Ativa o indicador de carregamento

      // Criar a data atual e subtrair 2 dias (para dataOntem)
      let dataAtual = new Date();
      dataAtual.setDate(dataAtual.getDate() - 2); // Subtrai 2 dias

      this.dt_geracao_afd = new Date();
      // Formatar a data de "dt_geracao_afd" no formato desejado com moment.js
      this.dt_geracao_afd = moment(this.dt_geracao_afd).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ); // Formatação desejada para a data atual

      // Formatar a data de ontem no formato desejado com moment.js
      let dataOntem = moment(dataAtual).format("YYYY-MM-DDTHH:mm:ssZ"); // Formatação da data de ontem

      let params = {
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
        empresa_id:
          this.value_empresa.length > 0
            ? `${[this.value_empresa.map((e) => e.id_empresa)]}`
            : `${[this.user.id_empresa]}`,
        filial_id:
          this.value_filial.length > 0
            ? `${[this.value_filial.map((e) => e.id_filial_erp)]}`
            : `${[this.user.id_filial_erp]}`,
        status_id:
          this.value_status.map((r) => r.id) !== ""
            ? `${[this.value_status.map((r) => r.id)]}`
            : null,
        dt_registro_inicio:
          this.dt_registro_inicio !== ""
            ? `${[this.dt_registro_inicio]}`
            : dataOntem, // Inclui a data de ontem no corpo da requisição
        dt_registro_fim:
          this.dt_registro_fim !== "" ? `${[this.dt_registro_fim]}` : dataOntem, // Inclui a data de ontem no corpo da requisição
      };

      const url = `${baseApiUrl}/pontoeletronico/afd/lancamentosafd`;
      axios
        .get(url, { params })
        .then((res) => {
          this.afdLancamentos = res.data;
          this.isLoading = false; // Desativa o indicador de carregamento
          this.loadPonLançamentosAfdCabecalho();
        })
        .catch(showError);
    },

    async putAfdExportado() {
      if (!this.afdLancamentos || this.afdLancamentos.length === 0) {
        this.$toasted.global.defaultError({
          message: "Por favor, a lista de lançamentos AFD está vazia.",
        });
        return;
      }

      const corpo = {
        psg: this.user.psg,
        afd_geracao_status: 2,
        afd_dt_geracao: new Date(),
        registros: this.afdLancamentos.map((item) => ({
          empresa_id: item.empresa_id,
          nsr: item.nsr.trim(), // importante remover espaços
        })),
      };

      const url = `${baseApiUrl}/pontoeletronico/afd/lancamentosafd`;

      try {
        const res = await axios.put(url, corpo);
        if (res.data && res.data.msg) {
          this.$toasted.global.defaultSuccess({
            msg: res.data.msg,
          });
        }
        this.loadPonLançamentosAfd();
      } catch (err) {
        showError(err);
      }
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.id_empresa == 2 ? "PSG_ML18" : this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadPonLançamentosAfdCabecalho() {
      //this.isLoading = true; // Ativa o indicador de carregamento
      let params = {
        psg: this.user.psg,
        origem: "cabecalho",
        empresa_id:
          this.value_empresa.length > 0
            ? `${[this.value_empresa.map((e) => e.id_empresa)]}`
            : `${[this.user.id_empresa]}`,
      };

      const url = `${baseApiUrl}/pontoeletronico/afd/cabecalho`;
      axios
        .get(url, { params })
        .then((res) => {
          this.afdCAbecalhos = res.data;
        })
        .catch(showError);
    },

    async generateAfdFile() {
      this.isLoading = true; // Ativa o indicador de carregamento
      const cabecalho = this.generateCabecalho();
      const trailer = await this.generateTrailer();
      const corpo = this.generateCorpo();
      const arquivoCompleto = `${cabecalho}${corpo}${trailer}`;

      console.log("Arquivo AFD gerado:", arquivoCompleto);

      // Cria um Blob com o conteúdo do arquivo
      const blob = new Blob([arquivoCompleto], { type: "text/plain" });
      const url = URL.createObjectURL(blob);

      // Cria um link de download
      const link = document.createElement("a");
      link.href = url;
      //link.download = 'arquivo_afd.txt';  // Nome do arquivo a ser baixado
      link.download = `arquivo_afd_${moment(this.dt_registro_inicio).format(
        "DD-MM-YYYY"
      )}_ate_${moment(this.dt_registro_fim).format("DD-MM-YYYY")}.txt`;

      // Simula o clique no link para iniciar o download
      link.click();

      // Libera o objeto URL depois de usar
      URL.revokeObjectURL(url);
      this.isLoading = false; // Ativa o indicador de carregamento
    },

    generateCabecalho() {
      let cabecalho = "";

      if (this.afdCAbecalhos && this.afdCAbecalhos.length > 0) {
        const cabecalhoData = this.afdCAbecalhos[0];

        // Verifica se 'this.dt_geracao_afd' é um valor válido
        let dtGeracaoFormatada = "";

        // Se 'this.dt_geracao_afd' já for uma string em formato ISO 8601 válido
        if (moment(this.dt_geracao_afd, moment.ISO_8601, true).isValid()) {
          dtGeracaoFormatada = moment(this.dt_geracao_afd).format(
            "YYYY-MM-DDTHH:mm:00ZZ"
          );
        } else {
          dtGeracaoFormatada = moment().format("YYYY-MM-DDTHH:mm:00ZZ");
        }

        // Concatenando os campos, um por vez, sem quebra de linha
        let stringParaCRC = ""; // Esta string será usada para calcular o CRC-16

        stringParaCRC += cabecalhoData.padrao.padEnd(9, " ");
        stringParaCRC += cabecalhoData.tipo_registro.padEnd(1, " ");
        stringParaCRC += cabecalhoData.tipo_identificador_empregador.padEnd(
          1,
          " "
        );
        stringParaCRC += cabecalhoData.cnpj_cpf.padEnd(14, " ");
        stringParaCRC += cabecalhoData.cno_caepf.padEnd(14, " ");
        stringParaCRC += cabecalhoData.razaosocial.padEnd(150, " ");
        stringParaCRC += cabecalhoData.numero_registro_inpi.padEnd(17, " ");
        stringParaCRC += this.dt_registro_inicio.padEnd(10, " ");
        stringParaCRC += this.dt_registro_fim.padEnd(10, " ");
        stringParaCRC += dtGeracaoFormatada.padEnd(24, " ");
        stringParaCRC += cabecalhoData.versao_leitura_afd.padEnd(3, " ");
        stringParaCRC +=
          cabecalhoData.tipo_identificador_fab_desenvolvedor_rep.padEnd(1, " ");
        stringParaCRC += cabecalhoData.cnpj_cpf_desenvolvedor_rep.padEnd(
          14,
          " "
        );
        stringParaCRC += cabecalhoData.modelo_repc.padEnd(30, " ");

        // Agora calculamos o CRC-16 dessa string concatenada
        const crc16 = this.calculateCRC16(stringParaCRC);

        // Adicionando o CRC-16 no final do cabeçalho
        cabecalho += stringParaCRC + crc16.padEnd(4, " ") + "\n";
      } else {
        cabecalho = "-";
      }

      return cabecalho;
    },

    // Função para calcular o CRC-16
    calculateCRC16(data) {
      let crc = 0xffff; // Valor inicial para CRC-16

      for (let i = 0; i < data.length; i++) {
        crc ^= data.charCodeAt(i); // XOR com o byte atual

        // Processamento do CRC bit a bit
        for (let j = 8; j > 0; j--) {
          if (crc & 0x0001) {
            crc = (crc >> 1) ^ 0xa001; // Polinômio 0xA001 (CRC-16-CCITT)
          } else {
            crc >>= 1;
          }
        }
      }

      // Retorna o CRC calculado em formato hexadecimal (sem '0x' e em maiúsculo)
      return crc.toString(16).toUpperCase().padStart(4, "0");
    },

    // Método para gerar o corpo
    generateCorpo() {
      let corpo = "";
      if (this.afdLancamentos && this.afdLancamentos.length > 0) {
        this.afdLancamentos.forEach((lancamento) => {
          const nsr = lancamento.nsr.toString().padEnd(9, " ");
          const tipoRegistro = lancamento.tipo_registro
            .toString()
            .padEnd(1, " ");
          const dtMarcacao = moment(lancamento.dt_marcacao).format(
            "YYYY-MM-DDTHH:mm:ssZZ"
          );
          //const dtMarcacao = lancamento.dt_marcacao.toString();
          const cpf = lancamento.cpf.toString().padEnd(12, " ");
          const dtGravacao = moment(lancamento.dt_gravacao).format(
            "YYYY-MM-DDTHH:mm:ssZZ"
          );
          //const dtGravacao = lancamento.dt_gravacao.toString();
          const identificadorColetor = lancamento.identificador_coletor
            .toString()
            .padEnd(2, " ");
          const onlineoffline = lancamento.marcacao; // online / offline
          const codigo_hash = lancamento.codigohash.padEnd(64, " ");
          corpo += `${nsr}${tipoRegistro}${dtMarcacao}${cpf}${dtGravacao}${identificadorColetor}${onlineoffline}${codigo_hash}\n`;
        });
      } else {
        corpo = "-";
      }
      return corpo;
    },

    // Método para gerar o trailer
    generateTrailer() {
      let trailer = "";
      if (this.afdLancamentos && this.afdLancamentos.length > 0) {
        const totalRegistrosTipo2 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 2)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistrosTipo3 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 3)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistrosTipo4 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 4)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistrosTipo5 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 5)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistrosTipo6 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 6)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistrosTipo7 = this.afdLancamentos
          .filter((s) => s.tipo_registro === 7)
          .length.toString()
          .padEnd(9, " ");
        const totalRegistros = "9".padEnd(1, " ");

        trailer = `${"999999999".padEnd(
          9,
          " "
        )}${totalRegistrosTipo2}${totalRegistrosTipo3}${totalRegistrosTipo4}${totalRegistrosTipo5}${totalRegistrosTipo6}${totalRegistrosTipo7}${totalRegistros}`;
      } else {
        trailer = "-";
      }
      return trailer;
    },

    handleCheckboxChange(value) {
      if (value === "true") {
        // Chame o método desejado aqui
        this.postSac();
      }
    },

    temporizador() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          this.loadPonLançamentosAfd();
        }
      }, 1000);
    },

    loadPonLançamentosAfdTratativas() {
      let params = {
        id_solicitacao: `${[this.sacsolicitacao.id_solicitacao]}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/id`;
      axios.get(url, { params }).then((res) => {
        this.afdLancamentostratativa = res.data.map((sacT) => {
          return {
            id_solicitacao: sacT.id_solicitacao,
            dt_resposta: sacT.dt_resposta,
            id_respondido: sacT.id_respondido,
            respondido: sacT.respondido,
            registro: sacT.registro,
            justificativa: sacT.justificativa,
            id_status_leitura: sacT.id_status_leitura,
            status: sacT.status,
          };
        });
      });
    },

    loadCarregaSac(afdLancamentos) {
      this.sacsolicitacao = { ...afdLancamentos };
    },
    loadCarregaSacT(afdLancamentostratativa) {
      this.afdLancamentostratativa = { ...afdLancamentostratativa };
    },

    reset() {
      this.idRetornoSolicitacao = "";
      this.sacsolicitacao.id_solicitacao = "";
      this.parecer = "";
      this.sacsolicitacao.parecer = "";
      this.afdLancamentostratativa = [];
    },

    limparFiltro() {
      this.search = "";
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadStatus();
    this.loadPonLançamentosAfd();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.9em;
}

#re-nome {
  font-size: 0.9em;
}

#funcao {
  font-size: 0.9em;
}

#re-solicitante {
  font-size: 0.9em;
  font-style: inherit;
}

#parecer {
  font-size: 0.9em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}

#resolicitante {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#cabecalho {
  font-size: 14px; /* Ajuste o tamanho da fonte conforme necessário */
}

#trailer {
  font-size: 12px; /* Ajuste o tamanho da fonte conforme necessário */
}
</style>
